const AlertColor = {
  pending: "#2ACAEA",
  fail: "#FF0000",
  success: "#0D571B",
  pendingYellow: "#E8B820",
};

export { AlertColor };
